/* eslint-disable import/prefer-default-export */
import { useStoreData } from 'stores/hooks';
import {
  getCurrentPatient,
  getCurrentPatientRequestStatus,
  getPatientAsync,
  getPatientList,
  getPatientListAsync,
  getPatientListRequestStatus,
  getPPCPatientList,
  getPPCPatientListAsync,
  getPPCPatientListRequestStatus,
  IGetPatientListAsync,
} from './patientsSlice';

export function useCurrentPatient(patientID: string) {
  return useStoreData(
    getCurrentPatient,
    getCurrentPatientRequestStatus,
    getPatientAsync,
    patientID,
  );
}

export function usePatientList(params: IGetPatientListAsync) {
  return useStoreData(
    getPatientList,
    getPatientListRequestStatus,
    getPatientListAsync,
    params,
  );
}

export function usePPCPatientList(params: IGetPatientListAsync) {
  return useStoreData(
    getPPCPatientList,
    getPPCPatientListRequestStatus,
    getPPCPatientListAsync,
    params,
  );
}
